export default "__VITE_ASSET__DCz_CzOO__"